import {
  LOGO,
  LOGO_COMPACT,
  LOGO_COMPACT_DARK,
  LOGO_COMPACT_DARK_SM_WEBP,
  LOGO_COMPACT_DARK_WEBP,
  LOGO_COMPACT_SM_WEBP,
  LOGO_COMPACT_WEBP,
  LOGO_DARK,
  LOGO_DARK_SM_WEBP,
  LOGO_DARK_WEBP,
  LOGO_ICON,
  LOGO_ICON_SM_WEBP,
  LOGO_ICON_WEBP,
  LOGO_SM_WEBP,
  LOGO_WEBP,
} from '@/assets';
import React from 'react';

export type BrandLogoVariant = 'full' | 'compact' | 'icon';
export type BrandLogoTone = 'light' | 'dark';

type BrandLogoImageProps = {
  alt: string;
  variant?: BrandLogoVariant;
  tone?: BrandLogoTone;
  className?: string;
  style?: React.CSSProperties;
  sizes?: string;
};

type ResponsiveAsset = {
  fallback: string;
  webp: string;
  webpSmall: string;
  smallWidth: number;
  largeWidth: number;
};

const ASSETS: Record<
  BrandLogoVariant,
  Record<BrandLogoTone, ResponsiveAsset>
> = {
  full: {
    light: {
      fallback: LOGO,
      webp: LOGO_WEBP,
      webpSmall: LOGO_SM_WEBP,
      smallWidth: 960,
      largeWidth: 1800,
    },
    dark: {
      fallback: LOGO_DARK,
      webp: LOGO_DARK_WEBP,
      webpSmall: LOGO_DARK_SM_WEBP,
      smallWidth: 960,
      largeWidth: 1800,
    },
  },
  compact: {
    light: {
      fallback: LOGO_COMPACT,
      webp: LOGO_COMPACT_WEBP,
      webpSmall: LOGO_COMPACT_SM_WEBP,
      smallWidth: 560,
      largeWidth: 1100,
    },
    dark: {
      fallback: LOGO_COMPACT_DARK,
      webp: LOGO_COMPACT_DARK_WEBP,
      webpSmall: LOGO_COMPACT_DARK_SM_WEBP,
      smallWidth: 560,
      largeWidth: 1100,
    },
  },
  icon: {
    light: {
      fallback: LOGO_ICON,
      webp: LOGO_ICON_WEBP,
      webpSmall: LOGO_ICON_SM_WEBP,
      smallWidth: 128,
      largeWidth: 256,
    },
    dark: {
      fallback: LOGO_ICON,
      webp: LOGO_ICON_WEBP,
      webpSmall: LOGO_ICON_SM_WEBP,
      smallWidth: 128,
      largeWidth: 256,
    },
  },
};

const BrandLogoImage: React.FC<BrandLogoImageProps> = ({
  alt,
  variant = 'full',
  tone = 'light',
  className,
  style,
  sizes = '100vw',
}) => {
  const asset = ASSETS[variant][tone];

  return (
    <picture>
      <source
        type="image/webp"
        srcSet={`${asset.webpSmall} ${asset.smallWidth}w, ${asset.webp} ${asset.largeWidth}w`}
        sizes={sizes}
      />
      <img
        alt={alt}
        src={asset.fallback}
        className={className}
        style={style}
        decoding="async"
      />
    </picture>
  );
};

export default BrandLogoImage;
